import axios from 'axios'
import { useState } from 'react'
import {Modal} from 'react-bootstrap'

const AddNewAccount = ({show, setShow, formData, action, setFormData, setNotification, setReRender}) => {
    const [loader, setLoader] = useState(false);

    const handlers = {
        addNewAccount(e){
            e.preventDefault();
            setLoader(true);
            axios.post('/api/extension/v1/accounts', formData)
                .then((res) => {
                    setNotification({show: true, type: "success", text: res.data.message.en});
                    setTimeout(() => {
                        setNotification({show: false, title: "", text: ""});
                    }, 3000);
                    setLoader(false);
                    setShow((prev) => ({...prev, createAccount: false}));
                    setReRender((prev) => prev + 1)
                })
                .catch((err) => {
                    setNotification({show: true, type: "error", text: err.response.data.message.en});
                    setTimeout(() => {
                        setNotification({show: false, title: "", text: ""});
                    }, 3000);
                    setLoader(false);
                })
        },
        editAccount(e){
            e.preventDefault();
            setLoader(true);
            axios.put(`/api/extension/v1/accounts/${formData.id}`, formData)
                .then((res) => {
                    setNotification({show: true, type: "success", text: res.data.message.en});
                    setTimeout(() => {
                        setNotification({show: false, title: "", text: ""});
                    }, 3000);
                    setLoader(false);
                    setShow((prev) => ({...prev, createAccount: false}));
                    setReRender((prev) => prev + 1)
                })
                .catch((err) => {
                    setNotification({show: true, type: "error", text: err.response.data.message.en});
                    setTimeout(() => {
                        setNotification({show: false, title: "", text: ""});
                    }, 3000);
                    setLoader(false);
                })
        }
    }

    return(
        <Modal show={show} onHide={() => setShow((prev) => ({...prev, createAccount: false}))} size='lg' centered>
            <Modal.Header closeButton><h2 className="modal-title-text">Add New Account</h2></Modal.Header>
            <Modal.Body>
                <div className='container'>
                    <form className='row' onSubmit={handlers[action == "add" ? "addNewAccount" : "editAccount"]}>
                        <div className="col-md-6 mb-4">
                            <div className="form-group">
                                <label htmlFor="form-buyer">Buyer*</label>
                                <input id="form-buyer" required placeholder="Enter buyer number" type="text" className="form-control" name="buyer" value={formData.buyer} onChange={(e) => setFormData((prev) => ({...prev, buyer: e.target.value}))}/>
                            </div>
                        </div>
                        <div className="col-md-6 mb-4">
                            <div className="form-group">
                                <label htmlFor="form-password">Password*</label>
                                <input id="form-password" required placeholder="Enter password" type="text" className="form-control" name="password" value={formData.password} onChange={(e) => setFormData((prev) => ({...prev, password: e.target.value}))}/>
                            </div>
                        </div>
                        <div className="col-md-6 mb-4">
                            <div className="form-group">
                                <label htmlFor="form-auction">Auction*</label>
                                <select id="form-auction" required className="form-control" name="auction" value={formData.auction} onChange={(e) => setFormData((prev) => ({...prev, auction: e.target.value}))}>
                                    <option value={""}>Select Auction</option>
                                    <option value={"copart"}>Copart</option>
                                    <option value={"iaai"}>IAAI</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-md-6 mb-4">
                            <div className="form-group">
                                <label htmlFor="form-comment">Comment*</label>
                                <input id="form-comment" required placeholder="Enter comment" type="text" className="form-control" name="comment" value={formData.comment} onChange={(e) => setFormData((prev) => ({...prev, comment: e.target.value}))}/>
                            </div>
                        </div>
                        <div className="modal-action-buttons">
                            <button type="submit" disabled={loader} className="submit-modal-form-btn">{loader ? <div className="button-loader"></div> : (action == "add" ? "Submit" : "Save")}</button>
                            <button type="button" onClick={() => setShow((prev) => ({...prev, createAccount: false}))} className="cancel-modal-form-btn">Cancel</button>
                        </div>
                    </form>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default AddNewAccount